<template>
	<div id='' class='gPageBorder' v-loading='loading'>

		<tyc :tqobj='tqobj'></tyc>
		<!-- <tagc :tagobj='tagobj'></tagc> -->

		<pushdia :pObj='pObj'></pushdia>

		<div id=''>
			<div style=''>

				<el-row>
					<el-col :span="8" class=''>
						<el-button class='gSgLeftBtn' type='primary' @click='jumpToUpload'>{{$t('app_newtask')}}
						</el-button>
						<el-button :disabled="batchData.length == 0 || cantdel" class='' type='danger'
							@click='batchDel'>{{$t('app_mulDel')}}</el-button>
					</el-col>


					<el-col :offset="4" :span="4">
						<div class='gCtrl'>
							<el-select v-model="ftype" :placeholder="$t('app_filetype')" @change='fileTypeChange'>
								<el-option v-for="item in tsTypes" :key="item.type" :label="item.name"
									:value="item.type">
								</el-option>
							</el-select>

						</div>
					</el-col>

					<el-col :span="4">
						<div class='gCtrl'>
							<el-input :placeholder="$t('app_taskName')" v-model='queryKey' @keyup.enter.native='query'
								icon="search" :on-icon-click="query"></el-input>
						</div>
					</el-col>

					<el-col :span="4">
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_deviceNo')" v-model='terno' @keyup.enter.native='query'
								icon="search" :on-icon-click="query"></el-input>
						</div>
					</el-col>

				</el-row>


			</div>
		</div>


		<!-- <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

		<div id=''>
			<el-table @row-click='cellClick' :data="tableData" border ref="multipleTable" @sort-change="sortChange"
				class='tbPoint gTopMg' @selection-change="handleSelectionChange" style="width: 100%;border:none;">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column header-align='center' align='center' prop="taskName" sortable="custom"
					:label="$t('app_taskName')" width="">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="subTasks" :label="$t('app_subtsnum')"
					width="">
				</el-table-column>

				<!-- <el-table-column
          header-align='center'
          align='center'
          prop="fileName"
          :label="$t('app_filename')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          width=''
          :label="$t('app_version')">
        </el-table-column> -->

				<el-table-column header-align='center' align='center' prop="terNum" width=''
					:label="$t('app_deviceNum')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="success" width=''
					:label="$t('app_success')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="fail" width='' :label="$t('app_fail')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="other" width='' :label="$t('app_other')">
				</el-table-column>

				<!-- <el-table-column
          header-align='center'
          align='center'
          prop="fileStatus"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.fileStatus).style'>{{getStatus(scope.row.fileStatus).vl}}</label>
          </template>
        </el-table-column> -->

				<el-table-column header-align='center' align='center' sortable="custom" prop="createTime" width='175'
					:label="$t('app_createTime')">
				</el-table-column>

				<el-table-column header-align='center' align='right' prop="operate" width='106'
					:label="$t('app_operate')">
					<template slot-scope='scope'>

						<!-- <el-button v-show='1' type=text @click='pushdev = true'>{{$t('app_adddv')}}</el-button> -->
						<!-- <el-button v-show='1' type=text @click='deleteApp(scope.row)'>{{$t('app_cancel')}}</el-button> -->

						<el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
							<el-button v-show="scope.row.terNum == 0" type=text @click='editRow(scope.row)'><i
									class="fa fa-pencil" style=""></i></el-button>
						</el-tooltip>

						<!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
						<el-tooltip class="item" effect="dark" :content="$t('app_adddv')" placement="top">
							<el-button type='text'  @click='addDev(scope.row)'><i
									class="fa fa-plus" style=""></i></el-button>
						</el-tooltip>

						<el-tooltip v-if="scope.row.success == scope.row.terNum" class="item" effect="dark"
							:content="$t('app_del')" placement="top">
							<el-button type='text' @click='cancelPush(scope.row)'><i class="fa fa-trash-o"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>

					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style=''>
				<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="$gRow" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<style>
	/* html,body{width:100%;height:100%;}*/

	.tbPoint td {
		cursor: pointer
	}

	.cmMarginFrame {
		width: calc(100% - 20px);
		height: 100%;
		background: none;
		margin-left: 10px;
	}

	#appDepot {
		min-width: 840px;
	}

	#adData {}
</style>

<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import mm from 'moment'
	import pushdia from './pushdia.vue'

	import tyc from '@/components/global/tyc.vue'
	import tagc from '@/components/global/tagc.vue' 

	export default {

		data() {
			var that = this
			return {
				batchData: [],
				orderName: '',
				orderType: '',
				tsTypes: [],
				pObj: '',
				tqobj: '',
				// tagobj: {vl: '2', type: 'terSt'},
				popover5: false,
				pushdev: false,
				mechanismData: {
					callback(value) {
						// that.mech = value
						that.selectChange(value)
					}
				},
				info: {},
				listKey: 'launch-list',
				tableData1: [],
				page1: 1,
				total1: 0,
				missionNames: '',
				missionList: '',
				cerDialogVisible: false,
				cerTipDialogVisible: false,
				dvLoading: 0,
				index: 1,
				appId: '',
				stModel: [{
						label: this.$t('app_online'),
						vl: '1'
					},
					{
						label: this.$t('app_offline'),
						vl: '2'
					},
					{
						label: this.$t('app_new'),
						vl: '0'
					}
				],
				channels: [],
				cmsts: [],
				srchValue: '',
				channelId: '',
				cerTipMsg: '',
				status: '',
				dvIndex: 1,
				ftype: '',
				sftype: '',
				dialogVisible: 0,
				mechanismId: window.localStorage['mechanismId'],
				selectMid: '',
				tableData: [],
				dvTableData: [],
				appTypes: [],
				appTypeValue: '',
				appStatus: [{
						label: this.$t('app_prePushVerify'),
						value: '0'
					},
					{
						label: this.$t('app_preVerify'),
						value: '1'
					},
					{
						label: this.$t('app_verifyPass'),
						value: '2'
					},
					{
						label: this.$t('app_verifyNotPass'),
						value: '3'
					}
				],
				appStatusValue: '',
				total: 0,
				dvTotal: 0,
				loading: 0,
				appType: '',
				queryKey: '',
				terno: '',
				ftypes: '',
				getftype: '',
				sftypes1: [],
				sftypes2: [],
				sftypes3: [],
				sftypes5: [],
				sftypes6: [],
				sftypes7: [],
				sftypes9: [],
				sftypes10: [],
				getsftype: ''
			}
		},
		components: {
			MechanismSelector,
			pushdia,
			tyc,
			tagc
		},
		computed: {
			index() {
				var vl = this.$getWPage(this.listKey)
				return vl ? vl : 1
			},
			cantdel() {
				var is = false
				this.batchData.forEach(item => {
					if (item.terNum != item.success) {
						is = true
					}
				})
				return is
			},
			getDvStatus(value) {
				switch (value) {
					case '0':
						return this.$t('app_prePushVerify')
					case '1':
						return this.$t('app_preVerify')
					case '2':
						return this.$t('app_verifyPass')
					case '3':
						return this.$t('app_verifyNotPass')
				}
			}
		},
		methods: {
			batchDel() {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
					// console.log(obj)

					var tids = []
					this.batchData.forEach(item => {
						tids.push(item.taskId)
					})
					// console.log(this.batchDel, tids)
					this.$pTaskDelall(tids.toString(), (res) => {
						if (res.status == 200) {
							this.getList()
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					}, '')
				}, '')
			},
			handleSelectionChange(data) {
				this.batchData = data
			},
			sortChange(vl) {
				switch (vl.prop) {
					case 'taskName':
						this.orderName = '1'
						break
					case 'createTime':
						this.orderName = '2'
						break
				}
				this.orderType = vl.order == 'descending' ? 'desc' : 'asc'
				this.getList()
			},
			editRow(row) {
				this.$router.push({
					path: '/task/ptask/edit',
					query: {
						tid: row.taskId
					}
				})
			},
			cancelPush(row) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {
						// console.log(obj)
						this.$pTaskDelall(row.taskId, (res) => {
							if (res.status === 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, '')
					}, '')
				// this.$pushDownCtrl(row.taskId, row.taskId, '3', '', (res) => {
				//   if (res.status === 200) {
				//     this.$message.success(res.message)
				//   } else {
				//     this.$message.error(res.message)
				//   }
				//   this.dvLoading = 0
				// }, () => {
				//   // error
				//   this.dvLoading = 0
				// })
			},

			addDev(row) {
				console.log(row)
				var _this = this
				this.pObj = {
					type: 0, ////0task 1sysconfig
					taskId: row.taskId,
					taskType: row.taskType,
					close: () => {
						_this.pObj = ''
						_this.getList()
					}
				}
			},
			fileTypeChange(vl) {
				this.sftype = ''
				if (!vl) {
					this.cmsts = ''
				} else
					this.cmsts = this['sftypes' + vl]
				this.getList()
			},
			setft(row) {
				return this.getftype[row.fileType]
			},
			setsbt(row) {

				var vl = this.getsftype[row.subFileType]
				// console.log(row.subFileType, vl)
				return vl

				// return this.getsftype["6-1"]
			},
			pushCreateCer() {
				this.$router.push({
					path: "/certificate/new"
				})
			},
			pushUploadCer() {
				this.$router.push({
					path: "/certificate/upload"
				})
			},
			bindOperate(row) {
				//console.log(row)

				this.dvLoading = 1
				if (this.$appUrlTag === 0) {
					this.$bindApp('0', row.terminalNo, this.appId, (res) => {
						if (res.status === 200) {
							this.$message.success(this.$t('app_tipViewTask'))
						} else {
							this.$message.error(res.message)
						}
						this.dvLoading = 0
					}, () => {
						// error
						this.dvLoading = 0
					})
				} else {
					// console.log(localStorage.mechanismId, tNo)
					this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
						if (res.status === 200) {
							this.$message.success(this.$t('app_tipViewTask'))
						} else {
							this.$message.error(res.message)
						}
						this.dvLoading = 0
					}, () => {
						// error
						this.dvLoading = 0
					})
				}
			},
			getChannels() {
				this.$getChannelList(10000, 1, '', '', '', (res) => {
					if (res.status === 200) {
						this.channels = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			getStatus(value) {
				if (!value) return ''
				switch (value) {
					case '0':
						return {
							vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'
						}
						case '1':
							return {
								vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'
							}
							case '2':
								return {
									vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'
								}
								case '3':
									return {
										vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'
									}
				}
			},
			srchDevice() {
				this.getDevices()
			},
			selectDvChange(vl) {
				this.getDevices()
			},
			pageDvSized(val) {
				this.$gRow = val
				this.getDevices()
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : ''
				var channel = this.channelId ? this.channelId : ''
				var status = this.status ? this.status : ''
				var appId = this.appId ? this.appId : ''
				this.dvLoading = 1
				if (this.$appUrlTag === 0) {
					this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
						// console.log('dv', res)
						this.dvLoading = 0
						if (res.data) {
							this.dvTableData = res.data
							this.dvTotal = res.total
						}
					}, () => {
						// error
						this.dvLoading = 0
					})
				} else {

					this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
						console.log('dv', res)
						this.dvLoading = 0
						if (res.data) {
							this.dvTableData = res.data
							this.dvTotal = res.total
						}
					}, () => {
						// error
						this.dvLoading = 0
					})
				}

			},
			editApp(row) {
				this.$setWObj('fileEdit', {
					type: 1,
					data: row
				})
				this.$router.push({
					path: '/filemg/edit'
				})
			},
			pushApp(row) {

				//this.$setWObj('launcherPush', row)
				//this.$router.push({path: '/launch-push'})

				this.$setWObj('filePush', row)
				this.$router.push({
					path: '/filemg/push'
				})

			},
			query() {
				this.getList()
			},
			selectChange(vl) {
				this.selectMid = vl
				this.getList1()
			},
			reset() {
				this.queryKey = ''
				this.appType = ''
				this.getList()
			},
			pageSelect(index) {
				// this.$setWPage(this.listKey, index)
				this.index = index
				this.getList()
			},
			pageSelect1(index) {
				// this.$setWPage(this.listKey, index)
				this.page1 = index
				this.getList1()
			},
			pageDvSelect(index) {
				this.dvIndex = index
				this.getDevices()
			},
			pageSized(val) {
				this.$gRow = val
				this.getList()
			},
			pageSized1(val) {
				this.$gRow = val
				this.getList1()
			},
			deleteApp(obj) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {
						console.log(obj)
						this.$delfile(obj.fileId, (res) => {
							if (res.status === 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, '')
					}, '')
			},
			submitApp(obj) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {
						this.loading = 1
						this.$verifyFile(obj.fileId, '', '1', (res) => {
							this.loading = 0
							if (res.status === 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							this.loading = 0
						})

					}, '')
			},
			cellClick(row, ev, col) {
				if (!col.label || col.label === this.$t('app_operate')) {
					return
				}

				//console.log(row)
				// var isDetail = (row.status === '1' || row.status === '2')
				// var path = isDetail ? '/launch-detail' : '/launch-edit'
				// var key = isDetail ? 'launcherDetail' : 'launcherEdit'
				// var obj = isDetail ? row : {type: 1, data: row}

				// this.$setWObj(key, obj)

				this.$router.push({
					path: '/task/ptask/detail',
					query: {
						tid: row.taskId,
						tty: row.taskType
					}
				})

			},
			jumpToUpload() {
				this.$router.push({
					path: '/task/ptask/new'
				})
				// this.$setWObj('fileEdit', {type: 0})
				// this.$router.push({path: '/filemg/add'})
			},
			getList() {
				this.loading = 1
				var mech = this.selectMid ? this.selectMid : '' //渠道商id
				var name = this.queryKey ? this.queryKey : ''
				var type = this.ftype ? this.ftype : ''
				var stype = this.sftype
				var st = ''

				this.$pTaskList(this.index, this.$gRow, type, name, this.orderName, this.orderType, this.terno, (res) => {

					this.loading = 0
					if (res.status === 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message(res.message)
					}
				}, () => {
					this.loading = 0
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date === undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD HH:mm:ss')
			},
			setInstallType(type) {
				return this.$installType[type]
			}
		},
		mounted() {

			var _this = this
			this.tqobj = {
				keys: ['taskType', 'taskTypeArr', 'ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3',
					'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'taskTypeArr2', 'sftypes9'
				],
				callback: (data) => {
					_this.missionNames = data[0]
					_this.missionList = data[1]
					_this.ftypes = data[2]
					_this.getftype = data[3]
					_this.getsftype = data[4]
					_this.sftypes1 = data[5]
					_this.sftypes2 = data[6]
					_this.sftypes3 = data[7]
					_this.sftypes4 = data[8]
					_this.sftypes5 = data[9]
					_this.sftypes6 = data[10]
					_this.sftypes7 = data[11]
					_this.tsTypes = data[12]
					_this.sftypes9 = data[13]
				}
			}



			this.getList()

			/*this.$getAppTypeList(100000000, 1, (res) => {
			  if (res.status === 200) {
			    this.appTypes = res.data
			  } else {
			    this.$message(res.message)
			  }
			}, '')*/
		},
		destroyed() {}
	}
</script>



// WEBPACK FOOTER //
// list.vue?14f772d7